import { z } from "zod";

export const folderListFilterSchema = z.object({
  expertComptable: z.string().optional(),
  collaborator: z.string().optional(),
  myFolders: z.boolean().optional(),
});

export type FolderListFilterValues = z.infer<typeof folderListFilterSchema>;

export const defaultFolderListFilterValues: FolderListFilterValues = {
  expertComptable: "",
  collaborator: "",
  myFolders: false,
};
